import { render, staticRenderFns } from "./employeeGroupForm.vue?vue&type=template&id=2983ab9a"
import script from "./employeeGroupForm.vue?vue&type=script&lang=js"
export * from "./employeeGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports